import React from "react";
import { RaceWagerType } from "@tvg/ts-types/Race";
import { SimpleSelectAllContainer } from "../../styled-components";
import SimpleSelectionsButton from "./SimpleSelectionsButton";
import { filterSelectAllLabels, getPosition } from "../utils/utils";

interface SimpleSelectionsProps {
  selectionLabels: Array<string>;
  betType: RaceWagerType;
  isAllSelected: boolean[];
  onClickSelectAll: (position: number, isAllSelected: boolean) => void;
  isScrollableRacecard?: boolean;
  leg?: number;
}

const SimpleSelections = ({
  selectionLabels,
  betType,
  isAllSelected,
  onClickSelectAll,
  isScrollableRacecard,
  leg = 0
}: SimpleSelectionsProps) => {
  const selectAllLabels =
    selectionLabels &&
    betType &&
    filterSelectAllLabels(selectionLabels, betType);

  const renderButtons = () =>
    selectAllLabels &&
    isAllSelected &&
    selectAllLabels.map((label, index) => {
      const position = isScrollableRacecard ? leg : (index as number);
      return (
        <SimpleSelectionsButton
          key={`${label}-${betType.type.code}`}
          label={label}
          isAllSelected={isAllSelected[position]}
          onClickSelectAll={() =>
            onClickSelectAll(
              getPosition(position, betType),
              isAllSelected[position]
            )
          }
        />
      );
    });

  return <SimpleSelectAllContainer>{renderButtons()}</SimpleSelectAllContainer>;
};

export default SimpleSelections;
